<div class="visualization-container">

  <!-- Header - shown once, always -->
  <div class="visualization-header">
    <button class="back-button" (click)="onBackClick()" aria-label="Back to chat">
      <img src="assets/icons/collection-arrow.svg" alt="Back" class="back-arrow-icon">
    </button>
    <h1 class="visualization-title">Visualizations</h1>
  </div>
<div class="controls-row" *ngIf="!isLoading && !error">
  <!-- Toggle - shown once, only when there's data to toggle between -->
  <div class="view-toggle" *ngIf="!isLoading && !error">
    <button
      type="button"
      class="toggle-btn"
      [class.active]="viewMode === 'graph'"
      (click)="setViewMode('graph')">
      Graph
    </button>
    <button
      type="button"
      class="toggle-btn"
      [class.active]="viewMode === 'tree'"
      (click)="setViewMode('tree')">
      Tree
    </button>
  </div>
<!-- Document multi-select dropdown -->
    <div class="doc-filter">
      <button
        type="button"
        class="doc-filter-trigger"
        (click)="toggleDropdown()">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 4h12M4 8h8M6 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span class="doc-filter-label">{{ dropdownLabel }}</span>
        <svg
          class="chevron"
          [class.open]="isDropdownOpen"
          width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="doc-dropdown" *ngIf="isDropdownOpen">
        <div class="doc-dropdown-empty" *ngIf="documents.length === 0">
          No documents available
        </div>
        <ul class="doc-list" *ngIf="documents.length > 0">
          <li
            class="doc-item"
            *ngFor="let doc of documents"
            (click)="toggleDocument(doc.vectorKey)">
            <span class="doc-checkbox" [class.checked]="isSelected(doc.vectorKey)">
              <svg *ngIf="isSelected(doc.vectorKey)" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M1.5 5l2.5 2.5 4.5-4.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="doc-name" [title]="doc.documentName">{{ doc.documentName }}</span>
          </li>
        </ul>
      </div>
    </div>
</div>
  

  <!-- Loading state -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner"></div>
  </div>

  <!-- Error state -->
  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-content">
      <i class="fas fa-exclamation-triangle error-icon"></i>
      <p class="error-message">{{ error }}</p>
      <button class="retry-button" (click)="loadKnowledgeGraph()">
        <i class="fas fa-refresh"></i>
        Retry
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!isLoading && !error && relations.length === 0">
    <div class="empty-content">
      <div class="graph-icon-placeholder">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="16" r="6" fill="#E2E8F0"/>
          <circle cx="16" cy="48" r="6" fill="#E2E8F0"/>
          <circle cx="48" cy="48" r="6" fill="#E2E8F0"/>
          <line x1="28" y1="20" x2="18" y2="44" stroke="#CBD5E1" stroke-width="2" marker-end="url(#arrow)"/>
          <line x1="36" y1="20" x2="44" y2="44" stroke="#CBD5E1" stroke-width="2"/>
          <defs>
            <marker id="arrow" markerWidth="8" markerHeight="8" refX="8" refY="4" orient="auto">
              <path d="M0,0 L8,4 L0,8 Z" fill="#CBD5E1"/>
            </marker>
          </defs>
        </svg>
      </div>
      <h3 class="empty-title">No relationships available</h3>
      <p class="empty-message">There are no knowledge graph relationships to display at this time.</p>
    </div>
  </div>

  <!-- Graph/Tree panels - ONLY the canvas, only when there's data -->
  <div class="visualization-content" *ngIf="!isLoading && !error && relations.length > 0">

    <div class="view-panel" [hidden]="viewMode !== 'graph'">
      <div class="graph-wrapper">
        <app-graph [elements]="graphElements"></app-graph>
      </div>
    </div>

    <div class="view-panel" [hidden]="viewMode !== 'tree'">
      <div class="graph-wrapper">
        <app-tree [elements]="treeElements" direction="TB"></app-tree>
      </div>
    </div>

  </div>

</div>